import { useQuery } from "react-query";
import { clientsApi } from "frontend/src/api/clients";
import { clientsCacheKey } from "./shared";
export var useClients = function (request) {
    return useQuery([clientsCacheKey, request], function () { return clientsApi.getMany(request); });
};
export var useClient = function (id) {
    return useQuery([clientsCacheKey, id], function () { return clientsApi.getOne(id); });
};
